import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

// Import de la configuration i18n
import "./i18n/i18n";

// Patch pour éviter l'erreur ResizeObserver
const originalConsoleError = console.error;
console.error = (...args) => {
  if (
    args.length > 0 &&
    typeof args[0] === 'string' &&
    args[0].includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    // Ignorer cette erreur spécifique
    return;
  }
  originalConsoleError(...args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
